import * as React from "react";
import { cva } from "class-variance-authority";
import { cn } from "../../lib/utils";

const badgeVariants = cva(
  "inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold transition-colors",
  {
    variants: {
      variant: {
        default:   "bg-blue-100 text-blue-800",
        secondary: "bg-gray-100 text-gray-700",
        success:   "bg-green-100 text-green-800",
        warning:   "bg-yellow-100 text-yellow-800",
        danger:    "bg-red-100 text-red-800",
        new:       "bg-yellow-100 text-yellow-800",
        pending:   "bg-blue-100 text-blue-800",
        resolved:  "bg-green-100 text-green-800",
        hot:       "bg-red-100 text-red-700",
        warm:      "bg-orange-100 text-orange-700",
        cold:      "bg-cyan-100 text-cyan-700",
      },
    },
    defaultVariants: { variant: "default" },
  }
);

function Badge({ className, variant, ...props }) {
  return <span className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { Badge, badgeVariants };
